import React, { useState, useEffect } from 'react';
import {Link} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { updateUserStart } from './../redux/User/user.actions'
import Button from './../components/forms/Button'
import DashAuthWrapper from './../components/DashAuthWrapper'

const mapState = ({ user }) => ({
	currentUser: user.currentUser
})

const Unsubscribe = props => {
	const { currentUser } = useSelector(mapState);
	const history = useHistory();
	const dispatch = useDispatch();
	const [modalView, setModalView] = useState(false)

	const [displayName ] = useState(currentUser.displayName);
	const [address ] = useState(currentUser.address);
	const [address2] = useState(currentUser.address2);
	const [city] = useState(currentUser.city);
	const [state] = useState(currentUser.state);
	const [zip] = useState(currentUser.zip);
	const [phone] = useState(currentUser.phone);
	const [subscribed] = useState(false);
	let [fullAddress] = useState(currentUser.fullAddress);
	const [center] = useState(currentUser.center);
	const [EIN] = useState('NULL')
	const [contactName] = useState('NULL')
	const [contactEmail] = useState('NULL')

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	function unsubscribe(){
		setModalView(!modalView)
	}


	const handleUnsubscribe = () => {
		dispatch(updateUserStart({
			EIN,
			contactName,
			contactEmail,
			displayName,
			address,
			address2,
			city,
			state,
			zip,
			phone,
			subscribed,
			fullAddress,
			center
		}))
		history.push('/dashboard');
		
	};
	
	return (
		<div>
			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}
			{currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">Do you want to Unsubscribe or Edit your Subscription? </h3>  
					
				
					<div className="mt-5">
						<Link to="/services">
							<Button className="btn btn-primary serviceBtn">
								EDIT SUBSCRIPTION
							</Button>
						</Link>
						
						<Button className="btn cancel serviceBtn mx-3" onClick={unsubscribe}>
							UNSUBSCRIBE
						</Button>
						
						
					</div>

					{modalView && (
						<div className="modalOverlay">
							<div className="modalWrap">
								<div className="modalView d-flex flex-column justify-content-center">
									You are about to stop all services, are you sure you want to continue?
									
									<div className="row pt-5 mx-auto">
										<Button className="btn serviceBtn mr-3" onClick={unsubscribe}>
											KEEP SUBSCRIPTION
										</Button>
										<Link to="/dashboard">
											<Button className="btn cancel serviceBtn" onClick={() => handleUnsubscribe()}>
												UNSUBSCRIBE
											</Button>
										</Link>
									</div>

								</div>
							</div>
						</div>
					)}
				
				</DashAuthWrapper>
			)}
		</div>	




		
	)
}

export default Unsubscribe;